import { Typography } from '@/components/common';
import * as React from 'react';
import { FilterChip } from './FilterChip';
import { FilterMode } from './DocumentFilterPanel';

interface FilterHeaderBarProps {
	filterMode: FilterMode;
	setFilterMode: (mode: FilterMode) => void;
	chipsByFollowUp: Record<number, { name: string; count: number }>;
	handleRemoveFollowUpChip: (followUpId: number) => void;
}

export const FilterHeaderBar: React.FC<FilterHeaderBarProps> = ({
	// filterMode,
	// setFilterMode,
	chipsByFollowUp,
	handleRemoveFollowUpChip,
}) => {
	// ---------------- hide this feature ----------------------------//
	// const renderToggleButton = (mode: FilterMode, label: string) => {
	// 	const isActive = filterMode === mode;
	// 	return (
	// 		<button
	// 			type="button"
	// 			onClick={() => setFilterMode(mode)}
	// 			className="flex items-center gap-2"
	// 		>
	// 			<span
	// 				className={clsx(
	// 					'border-primary flex-shrink-0 inline-flex items-center justify-center rounded-full border w-6 h-6 transition-all duration-150',
	// 					isActive ? 'bg-primary' : 'bg-white'
	// 				)}
	// 			>
	// 				{isActive && (
	// 					<Icon
	// 						src={Icons.check}
	// 						width={14}
	// 						height={14}
	// 						className="text-white"
	// 					/>
	// 				)}
	// 			</span>
	// 			<Typography type="regular-16">{label}</Typography>
	// 		</button>
	// 	);
	// };

	return (
		<div className="flex items-start gap-4 px-8 py-4 border-y border-grey-100 bg-white flex-wrap">
			<div className="flex items-center gap-4 flex-shrink-0 justify-between w-full">
				<Typography type="semibold-16" className="text-black">
					Filter
				</Typography>

				{/* Include / Exclude toggles */}
				{/*<div className="flex items-center gap-4">
					{renderToggleButton('include', 'Include in filter')}
					{renderToggleButton('exclude', 'Exclude from filter')}
				</div>*/}
			</div>

			{/* Selected answer chips */}
			{Object.keys(chipsByFollowUp).length > 0 && (
				<div className="flex items-center gap-2 flex-wrap">
					{Object.entries(chipsByFollowUp).map(([fuId, { name, count }]) => (
						<FilterChip
							key={fuId}
							label={name}
							count={count}
							onRemove={() => handleRemoveFollowUpChip(Number(fuId))}
						/>
					))}
				</div>
			)}
		</div>
	);
};
